import { motion, useReducedMotion } from 'motion/react';

const variantClass = {
  primary: 'aui-btn-primary',
  secondary: 'aui-btn-secondary',
  ghost: 'aui-btn-ghost',
  danger: 'aui-btn-danger',
  success: 'aui-btn-success',
};

export default function Button({
  children,
  variant = 'primary',
  type = 'button',
  disabled = false,
  loading = false,
  iconLeft,
  iconRight,
  onClick,
  className = '',
  ...rest
}) {
  const reduceMotion = useReducedMotion();
  const cls = ['aui-btn', variantClass[variant] || variantClass.primary, className].filter(Boolean).join(' ');

  return (
    <motion.button
      type={type}
      className={cls}
      disabled={disabled || loading}
      onClick={onClick}
      whileTap={reduceMotion ? undefined : { scale: 0.97 }}
      {...rest}
    >
      {loading ? (
        <span className="aui-skeleton" style={{ width: '1rem', height: '1rem', borderRadius: '50%', display: 'inline-block' }} />
      ) : (
        <>
          {iconLeft}
          {children}
          {iconRight}
        </>
      )}
    </motion.button>
  );
}
